import { render, staticRenderFns } from "./subsidyList.vue?vue&type=template&id=174e7c16&scoped=true"
import script from "./subsidyList.vue?vue&type=script&lang=js"
export * from "./subsidyList.vue?vue&type=script&lang=js"
import style0 from "./subsidyList.vue?vue&type=style&index=0&id=174e7c16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174e7c16",
  null
  
)

export default component.exports